class TerritorioLoadMore {
  constructor() {
    this.territorioData = this.loadData().sort((a, b) => this.compareEntries(a, b));
    this.itemsPerLoad = 18;
    this.currentIndex = 0;
    this.loadMoreBtn = document.getElementById('load-more-btn');
    this.loadMoreContainer = document.querySelector('.load-more-container');
    this.gridContainer = document.getElementById('territorio-grid-container');
    this.filteredData = [...this.territorioData];
    this.activeFilters = { sortOrder: '', year: '' };

    this.init();
  }

  loadData() {
    const dataScript = document.getElementById('territorio-data');
    if (!dataScript) return [];

    try {
      const data = JSON.parse(dataScript.textContent);
      return data.entries || [];
    } catch (e) {
      console.error('Erro ao parsear dados de territorio:', e);
      return [];
    }
  }

  init() {
    if (!this.loadMoreBtn || !this.loadMoreContainer || !this.gridContainer) {
      console.error('loadMoreBtn, loadMoreContainer ou gridContainer não encontrados');
      return;
    }

    if (this.territorioData.length === 0) {
      console.warn('Nenhum dado de territorio disponível');
      return;
    }

    this.loadMoreItems();

    this.loadMoreBtn.addEventListener('click', () => {
      this.loadMoreItems();
    });

    document.addEventListener('territorio-filter-change', (e) => {
      this.applyFilters(e.detail);
    });
  }

  // Converte a data de uma entrada num número para poder comparar
  getTimestamp(entry) {
    const campos = [entry.data_evento, entry.data, entry.data_horario, entry.nome_do_espaco_cidade_datas];

    // 1. Datas numéricas completas, em qualquer campo
    for (const campo of campos) {
      const val = String(campo || '');

      // DD/MM/AAAA, DD-MM-AAAA ou DD.MM.AAAA
      let m = val.match(/(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})/);
      if (m) return new Date(+m[3], +m[2] - 1, +m[1]).getTime();

      // AAAA-MM-DD
      m = val.match(/(\d{4})[\/\-.](\d{1,2})[\/\-.](\d{1,2})/);
      if (m) return new Date(+m[1], +m[2] - 1, +m[3]).getTime();
    }

    // 2. Mês por extenso (ex: "12 Maio 2026", "Setembro de 2026", "set 2026")
    const meses = {
      jan: 0, fev: 1, mar: 2, abr: 3, mai: 4, jun: 5,
      jul: 6, ago: 7, set: 8, out: 9, nov: 10, dez: 11
    };
    for (const campo of campos) {
      const val = String(campo || '')
        .toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // tira acentos

      const m = val.match(/(?:(\d{1,2})\s*(?:de\s+)?)?\b(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)[a-z]*\.?\s*(?:de\s+)?(\d{4})/);
      if (m) {
        const dia = m[1] ? +m[1] : 1;
        return new Date(+m[3], meses[m[2]], dia).getTime();
      }
    }

    // 3. Só o ano
    for (const campo of [...campos, entry.ano]) {
      const m = String(campo || '').match(/\b(19|20)\d{2}\b/);
      if (m) return new Date(+m[0], 0, 1).getTime();
    }

    return Infinity; // sem data
  }

  // Mais recente primeiro; entradas sem data vão para o fim
  compareEntries(a, b) {
    const ta = this.getTimestamp(a);
    const tb = this.getTimestamp(b);
    if (ta === tb) return 0;
    if (ta === Infinity) return 1;
    if (tb === Infinity) return -1;
    return tb - ta;
  }

  loadMoreItems() {
    const endIndex = Math.min(this.currentIndex + this.itemsPerLoad, this.filteredData.length);

    for (let i = this.currentIndex; i < endIndex; i++) {
      this.addEntryToGrid(this.filteredData[i]);
    }

    this.currentIndex = endIndex;

    this.loadMoreContainer.style.display =
      this.currentIndex >= this.filteredData.length ? 'none' : 'block';

    document.dispatchEvent(new CustomEvent('territorio-entries-loaded'));
  }

  applyFilters(filters) {
    const { year, sortOrder } = filters;
    this.activeFilters = filters;

    this.gridContainer.innerHTML = '';
    this.currentIndex = 0;

    this.filteredData = this.territorioData.filter(
      entry => !year || String(entry.ano) === String(year)
    );

    if (sortOrder === 'asc') {
      this.filteredData.sort((a, b) => a.titulo.localeCompare(b.titulo));
    } else if (sortOrder === 'desc') {
      this.filteredData.sort((a, b) => b.titulo.localeCompare(a.titulo));
    } else {
      this.filteredData.sort((a, b) => this.compareEntries(a, b));
    }

    this.loadMoreItems();
  }

  addEntryToGrid(entry) {
    const { ano, titulo, template_pagina, data_evento, imagem, categorias, artistas, nome_do_espaco_cidade_datas, data_horario, col_class, data_titulo, url_page } = entry;

    let mainGrid = this.gridContainer.querySelector('.territorio-main-grid');

    if (!mainGrid) {
      mainGrid = document.createElement('div');
      mainGrid.className = 'row territorio-main-grid';
      this.gridContainer.appendChild(mainGrid);
    }

    const entryDiv = document.createElement('div');
    entryDiv.className = `${col_class} col-12 territorio-entry`;
    entryDiv.setAttribute('data-year', ano);
    entryDiv.setAttribute('data-titulo', data_titulo);
    entryDiv.setAttribute('data-data', data_evento || '');

    let categoriasHTML = '';
    if (categorias && Array.isArray(categorias) && categorias.length > 0) {
      categoriasHTML = `
        <div class="tags tags-image yellow-tags">
          <div class="tags tags-image">
            ${categorias.map(cat => `<span>${cat}</span>`).join('')}
          </div>
        </div>
      `;
    }

    let artistasHTML = '';
    if (artistas && Array.isArray(artistas) && artistas.length > 0) {
      artistasHTML = `
        <div class="artista-event color-black text-uppercase paragraph-lg">
          ${artistas.map((artist, idx) => {
            const artistName = typeof artist === 'object' ? artist.titulo : artist;
            const comma = idx < artistas.length - 1 ? ', ' : '';
            return `<span>${artistName}</span>${comma}`;
          }).join('')}
        </div>
      `;
    }

    const locationHTML = nome_do_espaco_cidade_datas
      ? `<div class="event-location mt-3">${nome_do_espaco_cidade_datas}</div>`
      : '';

    const dateHTML = data_horario
      ? `<div class="event-datas">${data_horario}</div>`
      : '';

    entryDiv.innerHTML = `
      <div class="agenda-event position-relative pb-sm cartoes-territorios">
        <div class="image position-relative">
          ${imagem ? `
            <a href="${url_page}" title="${titulo}">
              <div class="ratio ratio-4x3">
                <img
                  src="${imagem}"
                  class="w-100 img-fluid object-fit-cover"
                  alt="${titulo}"
                >
              </div>
            </a>
          ` : ''}
          ${categoriasHTML}
        </div>
        <div class="info-agenda-event">
          ${template_pagina ? `<div class="category paragraph-sm">${template_pagina}</div>` : ''}
          <h3 class="event-title">
            <a
              href="${url_page}"
              class="no-decoration-black stretched-link"
              title="${titulo}"
            >
              ${titulo}
            </a>
          </h3>
          ${artistasHTML}
          ${locationHTML}
          ${dateHTML}
        </div>
      </div>
    `;

    mainGrid.appendChild(entryDiv);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new TerritorioLoadMore());
} else {
  new TerritorioLoadMore();
}